import React from 'react';

import { createStyles, Theme, withStyles } from '@material-ui/core/styles';
import {
  Button,
  TextField,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Paper,
  Grid
} from '@material-ui/core';
import { Close as CloseIcon } from '@material-ui/icons';

import linkIcon from '../../assets/link_blue.svg';
import tapaStyles from './tapa.module.css';
import Zoom from '@material-ui/core/Zoom';
import OrderDashboard from '../../models/OrderDashboard';
import moment from 'moment';
import TapaModel from '../../models/TapaForm';

const styles = (theme: Theme) =>
  createStyles({
    linkButtonContainer: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
    },
    linkButton: {
      transform: 'rotate(140deg)',
      cursor: 'pointer'
    },
    buttonContainer: {
      display: 'flex',
      justifyContent: 'space-between',
      width: '100%',
      padding: '0 15px 23px',
    },
    submitBtn: {
      fontSize: '13px'
    }
  });

interface LinkOrderComponentProps {
  classes: any;
  modalOpen: boolean;
  handleClose: (type: string) => void;
  unlinkedOrder: OrderDashboard;
  tapaForm: TapaModel;
  handleSubmit: (type: string, orderNumber: string, tapaId?: number) => void;
}

const linkOrderComponent = (props: LinkOrderComponentProps) => {
  const { classes } = props;

  return (
    <Dialog
      open={ props.modalOpen }
      onClose={ () => props.handleClose('link') }
      aria-labelledby='form-dialog-title'
      maxWidth={'sm'}
      fullWidth={ true }
      TransitionComponent={ Zoom }
      transitionDuration={ 500 }>
      <DialogTitle id='form-dialog-title'>
        <div className={ tapaStyles.dialogTitle }>
          <span className={ tapaStyles.name }>Link order to truck inspection</span>
          <IconButton
            aria-label='Close'
            className={ tapaStyles.close }
            onClick={ () => props.handleClose('linkclose') }>
            <CloseIcon color='primary' />
          </IconButton>
        </div>
        <hr />
      </DialogTitle>
      <DialogContent>
        <div> 
          <p className={ tapaStyles.confirmText }>Do you wish to link the following order & truck inspection form</p>
          <Grid container >
            <Grid item sm={5}>
              <div className={ tapaStyles.orderDetailsWrapper }>
                <p className={ tapaStyles.orderTitle }>Order</p>
                <div className={ tapaStyles.orderDetails }>
                    <p>{ props.unlinkedOrder.driver_name }</p>
                      <p>{ props.unlinkedOrder.order_type === 'do'
                  ? 'Drop Off'
                  : props.unlinkedOrder.order_type === 'po'
                  ? 'Pick Up'
                  : props.unlinkedOrder.isRfs
                  ? 'RFS'
                  : 'Interline'}{' '}
                - Order # { props.unlinkedOrder.number }</p>
                    <p>{ props.unlinkedOrder.delivery_company_name }</p>
                    <p>Check In -  { moment(props.unlinkedOrder.pickup_time_timestamp).format('DD MMM YY hh:mm') }</p>
                </div>
              </div>
            </Grid>

            <Grid item xs className={ classes.linkButtonContainer }>
              <img alt="logo" src={ linkIcon } className={ classes.linkButton }  />
            </Grid>

            <Grid item sm={5}>
              <div className={ tapaStyles.orderDetailsWrapper }>
                <p className={ tapaStyles.orderTitle }>Truck Inspection</p>
                <div className={ tapaStyles.orderDetails }>
                    <p>{ props.tapaForm.driver_name }</p>
                      <p>{ props.tapaForm.carrier }</p>
                    <p>Truck Plate - { props.tapaForm.truck_number }</p>
                    <p>Inspection Time  - { moment(props.tapaForm.create_date).format('DD MMM YY hh:mm') }</p>
                </div>
              </div>
            </Grid>
          </Grid>
        </div>
      </DialogContent>
      <DialogActions>
        <div className={ classes.buttonContainer }>
          <Button 
            className={ classes.submitBtn }
            variant="contained" 
            color="primary" 
          >
           Cancel
          </Button>
          <Button 
            className={ classes.submitBtn }
            variant="contained" 
            color="primary" 
            onClick={ () => props.handleSubmit('link', props.unlinkedOrder.number, props.tapaForm.id) }
          >
            Link Order 
          </Button>
        </div>
      </DialogActions>
    </Dialog>
  );
};

export default withStyles(styles)(linkOrderComponent);
